import axios from "axios";//原生的axios
import { registerAuthExpired } from './authExpired';
// const envUrl = "http://10.30.0.129:8091/" //张雨晴
// const envUrl = "http://10.9.17.16:8091/" //吴雨霏
// const envUrl = "http://localhost:8091/"
// const envUrl = "http://127.0.0.1/"
// const envUrl = "http://10.9.6.56:8091/" 
// const envUrl = "http://v.cqcf.com/" //服务器
// const envUrl = "http://10.200.0.197:8091/" //公司内部服务器
// const envUrl = "http://10.200.1.197:8091/" //错的测试登录的
const envUrl = "" //部署用的

/* 后端服务地址：SSE（EventSource）不能带请求头，只能自己拼 URL，所以这里对外导出一份 */
export const requestBaseUrl = envUrl;
//用来拦截用的
axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";
//创建一个单例
const http= axios.create({
  // baseURL:'/api',
  timeout:1200000,//响应时间
  // headers:{"Content-Type":"application/json;charset=utf-8"},
  // ✅ 自定义 transformResponse，保留大数字精度
  transformResponse: [function (data) {
    if (typeof data === 'string') {
      try {
        // 将超过安全整数的大数字转为字符串，防止精度丢失
        data = data.replace(/:(\s*)(\d{16,})([,}\s\r\n])/g, ':$1"$2"$3');
        return JSON.parse(data);
      } catch (e) {
        return data;
      }
    }
    return data;
  }]
})
 
//拦截器  -请求拦截
http.interceptors.request.use(config=>{
  //部分接口需要token
  let token=window.localStorage.getItem('token');

  // 特殊处理登录相关接口
  if (config.url && config.url.includes('api/')) {
    config.url = envUrl + config.url;
    
    // 登录接口不添加token
    if (config.url.includes('api/login') || config.url.includes('api/getPublicKey')|| config.url.includes('api/register')) {
      delete config.headers.Authorization;
    } else if (token) {
      config.headers.Authorization = token;
    }
  }
  
  return config;
},err=>{
  return Promise.reject(err)
})

/* ==================== 登录态失效（HTTP 401 / code=401）统一处理 ==================== */
// 判定与跳转逻辑见 @/utils/authExpired：清空登录信息 → 提示 → 跳转 #/login
// 这里挂在本实例的响应拦截器上（登录相关接口由登录页自行处理，不跳转）
registerAuthExpired(http);

//整体导出
export default http;

